/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { connect } from 'react-redux';
import { compose, withProps, lifecycle } from 'recompose';
import { propTypes as reduxFormPropTypes, Field, formValueSelector, FormSection } from 'redux-form';
import { Button, Row, Col } from 'reactstrap';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';

import withPropStateSyncToRedux from 'hoc/withPropStateSyncToRedux';
import CollapsibleContent from 'components/CollapsibleContent';
import FieldGroup from 'components/FieldGroup';
import dataLayerPush from 'services/dataLayer';

import { filterAndGroupAppliances } from './helpers/filterAndGroupAppliances';
import formData from './configs/form-data-config';
import reduxFormWithGeneratorNeedsConfig from './withReduxFormGeneratorNeedsConfig';
import { form as reduxFormName } from './configs/generator-needs-form-config';
import calculateSelections from './helpers/appliances';

const valueSelector = formValueSelector(reduxFormName);

const YourNeeds = ({
  applianceGroups = {},
  applianceCategories = [],
  previousStep,
  handleSubmit,
  selectedFilter,
}) => (
  <form onSubmit={handleSubmit}>
    <div>
      <div className="needs-header">
        <div className="upper-navigation">
          <button type="button" onClick={previousStep}><ChevronLeft /> Back</button>
          <button type="submit">Next <ChevronRight /></button>
        </div>
        <h2>What do you want to power?</h2>
        <div className="appliance-filters">
          {
            map(applianceCategories, category => (
              <span key={category.id}>
                <Field
                  name="Appliance Filter"
                  component="input"
                  type="radio"
                  className="appliance-filters__input"
                  id={category.id}
                  value={category.id}
                />
                <label className="appliance-filters__label" htmlFor={category.id}>
                  <span dangerouslySetInnerHTML={{ __html: category.label }} />
                </label>
              </span>
            ))
          }
        </div>
      </div>
      { selectedFilter === 'wholeHouse' && <p className="filter-description">Want to power your <b>whole house</b> during a utility outage? We’ve pre-selected several items for you below. Add or subtract items to get the best estimate for your home’s specific needs.</p> }
      { selectedFilter === 'essentials' && <p className="filter-description">Looking for enough power to keep the <b>just the essentials</b> running? Indicate how many of the following items you wish to power, and we’ll recommend the right generator for your home.</p> }
      <FormSection name="appliances">
        <Row className="justify-content-center">
          {
            map(applianceGroups, (fields, groupLabel) => (
              <Col xs={12} key={groupLabel}>
                <CollapsibleContent
                  className="appliance-list"
                  title={groupLabel}
                  openByDefault
                  enableForSizes="small"
                >
                  <FieldGroup fields={fields} />
                </CollapsibleContent>
              </Col>
            ))
          }
        </Row>
      </FormSection>
      <div className="footer-button">
        <Button
          type="button"
          onClick={previousStep}
          color="secondary"
          className="is-back"
        >
          Back
        </Button>
        <Button
          type="submit"
          color="primary"
        >
          Next
        </Button>
      </div>
      <p className="needs-small-copy">*Estimates based on average electrical ratings. Your home’s specifics may vary.</p>
    </div>
  </form>
);

YourNeeds.propTypes = {
  ...reduxFormPropTypes,
  previousStep: PropTypes.func.isRequired,
  applianceCategories: PropTypes.array.isRequired,
  applianceGroups: PropTypes.object.isRequired,
  selectedFilter: PropTypes.string.isRequired,
};

const enhance = compose(
  connect(
    (state) => {
      const homeSize = valueSelector(state, 'Square Footage');
      const selectedFilter = valueSelector(state, 'Appliance Filter');
      return {
        selectedFilter,
        calculations: calculateSelections({
          sqft: homeSize,
          selectedAppliances: valueSelector(state, 'appliances'),
          selectedFilter,
        }),
        forGtm: {
          zip: valueSelector(state, 'Zip Code'),
          homeSize,
        },
      };
    },
  ),
  withPropStateSyncToRedux('calculations', 'homeNeeds'),
  reduxFormWithGeneratorNeedsConfig,
  withProps(({ selectedFilter }) => ({
    applianceCategories: formData.appliances.categories,
    applianceGroups: filterAndGroupAppliances(selectedFilter, formData.appliances.fields),
  })),
  lifecycle({
    componentDidMount() {
      const { forGtm: { zip, homeSize } } = this.props;
      const payload = {
        event: 'calculator',
        zip,
        homeSize,
      };
      dataLayerPush(payload);
    },
  }),
);

export default enhance(YourNeeds);



// WEBPACK FOOTER //
// ./src/views/Home/components/YourNeeds.js